import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const DescripcionesPuestos = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Descripciones de Puestos</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>
                    <b>Puesto: PM</b>
                  </p>
                </td>
                <td>
                  <p>
                  Descripción
                  </p>
                </td>
                <td>

                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/descripciones-puestos/puesto-pm"
                  >
                    Procedimiento
                  </Button>            
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default DescripcionesPuestos;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
